module.exports = __webpack_public_path__ + "static/media/section2.e61ff8ea.png";